export default {
      id: "ic_arrow_down_black-usage",
      viewBox: "0 0 24 24",
      url: "/" + "images/icons.3.109.2.svg#ic_arrow_down_black-usage",
      toString: function () {
        return this.url;
      }
    }